import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { ExhibitionClient } from '@Pass-It-Down/exhibition-client'

const url = process.env.REACT_APP_SERVER_URL
const api = new ExhibitionClient({url})

export const loadPins = createAsyncThunk('pins/loadPins',
  async (params) => {
    const response = await api.story().getAllPinLocationsByExhibitId(params.exhibitId, 'map-exhibit', params.styleName)
    return response.map(p => {
     p.index = 50
     return p
    })
  })

export const pinsSlice = createSlice({
  name: 'pins',
  initialState: {
    pins: [],
    selectPin: null
  },
  reducers: {
    highlightPin: (state, action) => {
      state.pins.forEach(pin => {
        let image = pin.pinImage
        let zIndex = 50

        if(pin.id === action.id) {

          image = pin.pinImageSelected
          zIndex = 999
        }

        pin.image = image
        pin.zIndex = zIndex
      })
    }
  },
  extraReducers: {
    [loadPins.pending]: (state, action) => {
    },
    [loadPins.fulfilled]: (state, action) => {

      const pins = action.payload.map(p => {
        p.zIndex = 50
        return p
      })

      state.pins = [...pins]
    }
}})

export const highlightPin = (id) =>  {
  return {type: 'pins/highlightPin', id}
}


export const selectPins= state => state.pins.pins

export default pinsSlice.reducer
